import React from 'react'
import { Button } from './ui/button'
import { Badge } from './ui/badge'
import { X, Filter } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'

export default function CategoryFilter({ categories, selected, onChange }) {
  const handleToggle = (category) => {
    if (selected.includes(category)) {
      onChange(selected.filter(c => c !== category))
    } else {
      onChange([...selected, category])
    }
  }
  
  const clearAll = () => {
    onChange([])
  }
  
  return (
    <div className="flex items-center gap-2 p-4 border-b dark:border-gray-700 flex-wrap">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm">
            <Filter className="w-4 h-4 mr-2" />
            Filter Categories
            {selected.length > 0 && (
              <Badge className="ml-2 bg-indigo-600 text-white">{selected.length}</Badge>
            )}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56 max-h-96 overflow-y-auto">
          {categories.map(category => (
            <DropdownMenuCheckboxItem
              key={category}
              checked={selected.includes(category)}
              onCheckedChange={() => handleToggle(category)}
            >
              {category}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      
      {/* Selected Categories */}
      {selected.length > 0 && (
        <>
          <div className="flex flex-wrap gap-2 flex-1">
            {selected.map(category => (
              <Badge
                key={category}
                variant="secondary"
                className="cursor-pointer"
                onClick={() => handleToggle(category)}
              >
                {category}
                <X className="w-3 h-3 ml-1" />
              </Badge>
            ))}
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={clearAll}
          >
            Clear All
          </Button>
        </>
      )}
    </div>
  )
}
